export default __webpack_public_path__ + "static/media/svg-1.976cb5cb.png";